import React from 'react';
import { withNamespaces } from 'react-i18next';
import ErrorPage from '../../components/Simple/ErrorPage';
import { HTTPCodes } from '../../utils/Constants';

const Forbidden = (props) => {
  const { t } = props;
  return (
    <ErrorPage
      code={HTTPCodes.FORBIDDEN}
      title={t('forbiddenTitle')}
      subtitle={t('forbiddenSubtitle')}
      {...props}
    />
  );
};

export default withNamespaces()(Forbidden);
